export default __webpack_public_path__ + "svg/CompaniesLogos/logo_edefense.svg?6cffff83";